import { render } from "./BaseFileUpload.vue?vue&type=template&id=0b7c483b"
import script from "./BaseFileUpload.vue?vue&type=script&lang=js"
export * from "./BaseFileUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__